function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "aa"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37474",
  d: "M34.8-15.538a3.87 3.87 0 00-2.84-1.2h-5.68v-.062a3.072 3.072 0 00-.924-2.224 3.131 3.131 0 00-2.224-.924H12.866a3.152 3.152 0 00-2.258.924 3.131 3.131 0 00-.924 2.224v.068H4.038a3.87 3.87 0 00-2.84 1.2A4.068 4.068 0 000-12.7V4.342a3.87 3.87 0 001.2 2.84 4.068 4.068 0 002.84 1.2h27.919a3.87 3.87 0 002.84-1.2A4.068 4.068 0 0036 4.342V-12.7a3.87 3.87 0 00-1.2-2.838zm-.582 19.88h-.034a2.22 2.22 0 01-2.224 2.224H4.038a2.22 2.22 0 01-2.224-2.224V-12.7a2.2 2.2 0 01.65-1.574 2.2 2.2 0 011.574-.65h6.6a.92.92 0 00.924-.924v-.992a1.344 1.344 0 01.376-.958 1.344 1.344 0 01.958-.376h10.235a1.344 1.344 0 01.958.376 1.344 1.344 0 01.376.958v.992a.92.92 0 00.924.924h6.6a2.2 2.2 0 011.574.65 2.2 2.2 0 01.65 1.574z",
  transform: "translate(0 19.952)",
  fill: "#9aa0a7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bb"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37473",
  d: "M-330 1102.935h540.209V-74H-330z",
  transform: "translate(330 74)",
  fill: "#9aa0a7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "cc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37477",
  d: "M15.068-14.846a8.432 8.432 0 00-5.954 2.464 8.35 8.35 0 00-2.463 5.954A8.432 8.432 0 009.114-.474a8.35 8.35 0 005.954 2.464 8.432 8.432 0 005.954-2.464 8.35 8.35 0 002.464-5.954 8.432 8.432 0 00-2.464-5.954 8.432 8.432 0 00-5.954-2.464zM19.722-1.74A6.687 6.687 0 0115.068.176a6.687 6.687 0 01-4.653-1.916A6.541 6.541 0 018.5-6.394a6.687 6.687 0 011.916-4.654 6.541 6.541 0 014.654-1.916 6.687 6.687 0 014.654 1.916 6.541 6.541 0 011.916 4.654 6.4 6.4 0 01-1.918 4.654z",
  transform: "translate(-6.651 14.846)",
  fill: "#9aa0a7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "dd"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37480",
  d: "M21.463-11.516a1.677 1.677 0 001.677-1.677 1.677 1.677 0 00-1.677-1.677 1.677 1.677 0 00-1.677 1.677 1.677 1.677 0 001.677 1.677z",
  transform: "translate(-19.786 14.869)",
  fill: "#9aa0a7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2234"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2235",
  clipPath: "url(#aa)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2234",
  transform: "translate(-475.384 -77.858)",
  clipPath: "url(#bb)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37472",
  d: "M468.181 70.656h50.4v42.737h-50.4z",
  fill: "#9aa0a7"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2237",
  transform: "translate(9.581 7.356)",
  clipPath: "url(#cc)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2236",
  transform: "translate(-484.964 -85.215)",
  clipPath: "url(#bb)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37475",
  d: "M477.762 78.012h31.24v31.241h-31.24z",
  fill: "#9aa0a7"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2239",
  transform: "translate(28.503 7.322)",
  clipPath: "url(#dd)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2238",
  transform: "translate(-503.887 -85.181)",
  clipPath: "url(#bb)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37478",
  d: "M496.684 77.979h17.759v17.759h-17.759z",
  fill: "#9aa0a7"
}))));

function SvgUploadImage(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.997,
    height: 28.332,
    viewBox: "0 0 35.997 28.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.9e3063e5.svg";
export { ForwardRef as ReactComponent };